import { NavLink } from "react-router-dom";
import "./Tile.less";

const Tile = ({ children, href, onClick, style }) => {
  const El = href ? NavLink : "div";
  return (
    <El to={href} className="tile" style={style} onClick={onClick ? onClick : null}>
      {children}
    </El>
  );
};

export default Tile;
